<template>
  <v-card
    class="notificacao__card"
    elevation="1"
    :style="getNotificacoesPopupCardStyle()"
  >
    <v-card-title class="pb-0">
      <p class="full-width mb-0 pb-0 black--text">
        {{ getStatusText(notificacao.tipo) }}
      </p>
      <h3
        v-html="notificacao.referencia"
        v-if="notificacao.referencia"
        class="pb-2"
      ></h3>
    </v-card-title>
    <v-card-text
      class="pt-0 mt-0 grey--text text--darken-2"
      v-html="notificacao.mensagem"
    />

    <v-card-actions>
      <span class="time">
        {{ notificacao.data | moment("DD MMM[, às ]HH:mm") }}
      </span>
    </v-card-actions>
  </v-card>
</template>

<script lang="js">
import { getStatusText } from "@/libs/utils";

export default {
  name: "NotificacoesCard",

  data() {
    return {
      getStatusText
    };
  },
  props: ["notificacao"],
  methods: {
    getNotificacoesPopupCardStyle() {
      let style = [];
      let t = this;
      let status = this.notificacao.status;
      let color = this.grabNotificationColorByStatus(status);
      style.push({
        borderLeft: `2px solid ${color}`,
      });
      let visualizadaStyle = !this.notificacao.visualizada
        ? { backgroundColor: "rgba(242,245,245,0.8)" }
        : {};
      style.push(visualizadaStyle);

      return style;
    },
    grabNotificationColorByStatus(type) {
      let color = "";
      switch (type) {
        case "PERDA_TOMADORES_NOMEADOS":
          color = "#F5A623";
          break;

        case "APOLICES_VENCER":
          color = "#4589F3";
          break;

        case "ATUALIZAR_INF":
          color = "#FF9700";
          break;

        case "BOLETOS_VENCIDOS":
          color = "#F81C50";
          break;
      }

      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.notificacao__card .time {
  color: #a6a6a6;
}
</style>



// WEBPACK FOOTER //
// ./src/components/NotificacoesCard.vue